import React, {FC, ReactNode} from "react";
import MaterialSelector from "./MaterialSelector";
import {Controller} from "react-hook-form";

import {MenuItem} from "@material-ui/core";

interface FormMaterialSelectorProps {
    control: any;
    name: string;
    label: string;
    disabled?: boolean;
    defaultValue?: any;
    className?: string;
    children: React.ReactElement<typeof MenuItem>[] | null;
    startAdornmentIcon?: React.ReactNode;
    placeholder?: string;
    formatSelectedValue?: (selected: any) => React.ReactNode;
    rules?: any;
}

export const FormMaterialSelector: FC<FormMaterialSelectorProps> = ({ className, name, disabled, label, control, defaultValue, children, startAdornmentIcon, placeholder, formatSelectedValue, rules}) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => {
                return (
                    <MaterialSelector
                        key={field.value}
                        disabled={disabled}
                        defaultValue={defaultValue}
                        className={className}
                        value={field.value}
                        name={field.name}
                        label={label}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        errorMessage={fieldState.error?.message as string || ''}
                        startAdornmentIcon={startAdornmentIcon}
                        placeholder={placeholder}
                        formatSelectedValue={formatSelectedValue}
                    >
                        {children}
                    </MaterialSelector>
                )
            }}
        />
    );
};